import { FunctionComponent } from "react";
import { Button, PrimaryButton } from "../../../components/button";
import styled from "styled-components";
import { Flex } from "../../../components/layout";
import { FraudRoutes } from "../../kyc-kyb-aml/routes";
import { UsersRoutes } from "../../users/routes";
import { UISref } from "@uirouter/react";
const ButtonWrapper = styled.div`
  &:not(:last-child) {
    margin-right: 1em;
  }
`;

type EditButtonProps = {
  editing: boolean;
  setEditing: (e: boolean) => void;
  className?: string;
};

const EditButtons: FunctionComponent<EditButtonProps> = ({
  editing,
  setEditing,
  className,
}) => (
  <Flex className={className}>
    {editing ? (
      <>
        <ButtonWrapper>
          <PrimaryButton variant="outlined" onClick={() => setEditing(false)}>
            Cancel
          </PrimaryButton>
        </ButtonWrapper>
        <ButtonWrapper>
          <PrimaryButton type="submit">Save</PrimaryButton>
        </ButtonWrapper>
      </>
    ) : (
      <ButtonWrapper>
        <PrimaryButton onClick={() => setEditing(true)}>Edit</PrimaryButton>
      </ButtonWrapper>
    )}
  </Flex>
);

const StyledEditButtons = styled(EditButtons)`
  margin-right: 1em;
`;

export const Adornment: FunctionComponent<
  EditButtonProps & {
    credentialsId?: string;
    fraudCheckId?: string;
    onDeleteHandler: () => void;
  }
> = ({ credentialsId, fraudCheckId, onDeleteHandler, ...props }) => (
  <>
    <StyledEditButtons {...props} />
    <ButtonWrapper>
      <Button colour="danger" onClick={onDeleteHandler}>
        Delete
      </Button>
    </ButtonWrapper>
    {fraudCheckId ? (
      <UISref
        to={FraudRoutes.names.singleIndividualKyc}
        params={{ fraudCheckId }}
      >
        <ButtonWrapper>
          <Button colour="secondary" variant="outlined">
            View KYC
          </Button>
        </ButtonWrapper>
      </UISref>
    ) : null}
    {credentialsId ? (
      <UISref to={UsersRoutes.names.single} params={{ id: credentialsId }}>
        <ButtonWrapper>
          <Button colour="secondary">View User</Button>
        </ButtonWrapper>
      </UISref>
    ) : null}
  </>
);
